import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
import {BeforeSeasonEvaluationEvent} from "@/modules/season/events/BeforeSeasonEvaluationEvent";
import {Application} from "@/di";
import {Router} from "vue-router";
import {TYPES} from "@/modules/vue";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";
import {Player} from "@/modules/team/entity";

@injectable()
export class SeasonEvaluationSubscriber implements EventSubscriber {
  constructor(
    @inject(Application) private app: Application,
    @inject(GlobalResolver) private globalResolver: GlobalResolver,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeSeasonEvaluationEvent, callback: this.onBeforeSeasonEvaluationEvent},
      {event: AfterSeasonEvaluationEvent, callback: this.onAfterSeasonEvaluationEvent},
    ];
  }

  async onBeforeSeasonEvaluationEvent(event: BeforeSeasonEvaluationEvent): Promise<void> {
    await this.globalResolver.startPromise(() => {
      this.app.get<Router>(TYPES.VueRouter).push({name: 'players.leaving'});
    });
  }

  async onAfterSeasonEvaluationEvent(event: AfterSeasonEvaluationEvent): Promise<void> {
    await Player
      .createQueryBuilder('player')
      .update()
      .set({
        age: () => 'age + 1',
      })
      .execute();
  }
}